import { ISiteAdminSettings, ISiteSubscriptionSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateSiteSettingsForSiteAdminParams {
  id: string;
  siteAdminSettings: ISiteAdminSettings;
  subscriptionSettings?: ISiteSubscriptionSettings;
}

export interface IUpdateSiteSettingsForSiteAdminResult {
}

export class UpdateSiteSettingsForSiteAdminRequest extends Request<IUpdateSiteSettingsForSiteAdminParams, IUpdateSiteSettingsForSiteAdminResult> {
  constructor(params: IUpdateSiteSettingsForSiteAdminParams) {
    super('updateSiteSettingsForSiteAdmin', params);
  }
}
